export default __webpack_public_path__ + "static/media/UNSAFE CONDITION IN ROTATING SHAFT WITH  LOOS CLOTH SIMULATOR.6fb9e778.jpg";